import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { FiArrowLeft, FiEdit, FiTrash } from "react-icons/fi";
import {
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
  FaChevronDown,
  FaChevronRight,
} from "react-icons/fa";
import TraineeHeader from "./TraineeHeader";
import Footers from "../Home/Footers";
import FemaleLogo from "../Courses//FemaleLogo.jpg";
import MaleLogo from "../Courses/MaleLogo.jpg"
import AxiosInstance from "../Home/AxiosInstance"
import Profile from "../Home/Profile.png";
import axios from "axios";
import "./traineePortal.css";
import "./MyCourseMaterial.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default function MyCourseMaterial() {
  const navigate = useNavigate();
  const { batchId } = useParams();
  const courseMaterialId = localStorage.getItem("course_material_id");
  const currentTraineeId = localStorage.getItem("traineeId");
  const [courseData, setCourseData] = useState(null);
  const [topics, setTopics] = useState([]);
  const [expandedTopic, setExpandedTopic] = useState(null);
  const [expandedSubtopic, setExpandedSubtopic] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [userReview, setUserReview] = useState(null); 
  const [ratingInput, setRatingInput] = useState(0);
  const [reviewInput, setReviewInput] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [showEditReviewModal, setShowEditReviewModal] = useState(false);
  const [loadError, setLoadError] = useState("");

  // Fetch reviews
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await AxiosInstance.get(
          `companies/reviews/${batchId}/`
        );
        setReviews(response.data || []);

        // Find review by current trainee
        const existingReview = (response.data || []).find(
          (rev) =>
            rev.trainee.trainee_id.toString() === currentTraineeId?.toString()
        );

        if (existingReview) {
          setUserReview(existingReview);
          setRatingInput(existingReview.rating);
          setReviewInput(existingReview.review);
          setIsEditing(false);
        } else {
          setUserReview(null);
          setRatingInput(0);
          setReviewInput("");
          setIsEditing(false);
        }
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };

    fetchReviews();
  }, [batchId, currentTraineeId]);

  // POST or PUT review handler
  const handleSubmitReview = async () => {
    try {
      if (!ratingInput || ratingInput < 1 || ratingInput > 5) {
        alert("Please provide a rating between 1 and 5.");
        return;
      }

      const payload = {
        review: reviewInput,
        rating: ratingInput,
        batch: parseInt(batchId),
        trainee: parseInt(currentTraineeId),
      };

      if (userReview) {
        // PUT existing review
        const res = await AxiosInstance.put(
          `companies/course/reviews/${userReview.review_id}/`,
          payload
        );
        setUserReview(res.data);
      } else {
        // POST new review
        const res = await AxiosInstance.post(
          `companies/reviews/`,
          payload
        );
        setUserReview(res.data);
      }

      alert("Review submitted successfully!");
      setIsEditing(false);

      // Refresh review list
      const response = await AxiosInstance.get(
        `companies/reviews/${batchId}/`
      );
      setReviews(response.data || []);
    } catch (error) {
      console.error("Error submitting review:", error);
      alert("Failed to submit review.");
    }
  };

  const handleDeleteReview = async () => {
    if (!userReview) return;

    const confirmDelete = window.confirm(
      "Are you sure you want to delete your review?"
    );
    if (!confirmDelete) return;

    try {
      await AxiosInstance.delete(
        `companies/review/${userReview.review_id}/`
      );

      alert("Review deleted successfully!");
      setUserReview(null);
      setRatingInput(0);
      setReviewInput("");
      setIsEditing(false);
    } catch (error) {
      console.error("Error deleting review:", error);
      alert("Failed to delete review.");
      return; // Stop here if deletion fails
    }

    // Refresh reviews separately
    try {
      const response = await AxiosInstance.get(
        `companies/reviews/${batchId}/`
      );
      setReviews(response.data || []);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // No reviews left, set empty array
        setReviews([]);
      } else {
        console.error("Error fetching reviews:", error);
        // Optional: alert only for real errors
        alert("Failed to refresh reviews.");
      }
    }
  };

  useEffect(() => {
    if (!batchId) return;

    (async () => {
      let materialId = courseMaterialId;
      try {
        setLoadError("");
        const response = await AxiosInstance.get(
          `companies/batches/${batchId}/`
        );
        if (response.data && response.data.length > 0) {
          const batch = response.data[0];
          setCourseData(batch);
          materialId =
            batch.course_material?.course_material_id || courseMaterialId;
          if (materialId) {
            localStorage.setItem("course_material_id", materialId);
          }
        } else {
          setLoadError("Course batch not found.");
          return;
        }
      } catch (error) {
        console.error("Error fetching course materials:", error);
        setLoadError("Failed to load course data.");
        return;
      }

      if (!materialId) return;
      try {
        const topicsRes = await AxiosInstance.get(
          `companies/topics/${materialId}/`
        );
        const topicsData = topicsRes.data || [];
        const topicsWithSubtopics = await Promise.all(
          topicsData.map(async (topic) => {
            try {
              const subtopicsRes = await AxiosInstance.get(
                `companies/sub-topics/${topic.topic_id}/`
              );
              return { ...topic, subtopics: subtopicsRes.data };
            } catch (err) {
              console.error(
                `Error fetching subtopics for topic ${topic.topic_id}:`,
                err
              );
              return { ...topic, subtopics: [] };
            }
          })
        );
        setTopics(topicsWithSubtopics);
      } catch (error) {
        console.error("Error fetching topics:", error);
      }
    })();
  }, [batchId, courseMaterialId]);

  if (loadError) {
    return (
      <div className="text-center p-5">
        <p className="text-danger mb-3">{loadError}</p>
        <button className="btn btn-primary" onClick={() => navigate(-1)}>
          Go back
        </button>
      </div>
    );
  }

  if (!courseData) return <p className="text-center">Loading course data...</p>;

  const { course_material } = courseData;
  const { user, trainer, description } = course_material;
  const getDisplayName = (person) =>
    person?.alias_name?.trim() || `${person?.first_name} ${person?.last_name}`;

  function formatContent(text) {
    if (!text) return "";

    const lines = text
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line !== "");
    const output = [];

    let listBuffer = [];

    const flushList = () => {
      if (listBuffer.length > 0) {
        output.push(
          `<ul>${listBuffer.map((item) => `<li>${item}</li>`).join("")}</ul>`
        );
        listBuffer = [];
      }
    };

    lines.forEach((line) => {
      if (/^[-*]\s+/.test(line)) {
        // It's a bullet point
        listBuffer.push(line.replace(/^[-*]\s+/, "").trim());
      } else {
        // Not a bullet: flush previous list and add paragraph
        flushList();
        output.push(`<p>${line}</p>`);
      }
    });

    // Flush any remaining bullets
    flushList();

    return output.join("");
  }

  return (
    <div className="TraineePage als-trainee-page">
      <TraineeHeader />
      <section className="cm-hero">
        <div className="cm-hero-inner">
          <button
            className="btn btn-outline-primary back-button d-inline-flex align-items-center gap-2 mb-3"
            onClick={() => navigate("/trainee-profile")}
            style={{
              background: "transparent",
              color: "#fff",
              borderColor: "rgba(255,255,255,0.35)",
            }}
          >
            <FiArrowLeft /> Back to dashboard
          </button>
          <div className="top-block">
            <div className="course-header">
              <h1 className="course-title">
                {courseData.course_material.course.course_name}
              </h1>
            </div>

            <div className="cm-hero-cards">
              <div className="batch-details card-custom">
                <div className="batch-meta-grid">
                  <div className="batch-meta-item">
                    <span className="batch-meta-label">Batch Starts At</span>
                    <span className="batch-meta-value">
                      {courseData.batch_starts_at}
                    </span>
                  </div>
                  <div className="batch-meta-item">
                    <span className="batch-meta-label">Timings</span>
                    <span className="batch-meta-value">
                      {courseData.timings} ({courseData.timezone})
                    </span>
                  </div>
                  <div className="batch-meta-item">
                    <span className="batch-meta-label">Duration</span>
                    <span className="batch-meta-value">{courseData.duration}</span>
                  </div>
                  <div className="batch-meta-item">
                    <span className="batch-meta-label">Mode</span>
                    <span className="batch-meta-value">{courseData.mode}</span>
                  </div>
                </div>
              </div>

              <div className="User-details card-custom">
                {courseData.course_material.user ? (
                  <>
                    <img
                      src={
                        courseData.course_material.user.image_path
                          ? `${AxiosInstance.defaults.baseURL}/media/${courseData.course_material.user.image_path.replace(
                              /\\/g,
                              "/"
                            )}`
                          : courseData.course_material.user.gender === "Male"
                          ? MaleLogo
                          : FemaleLogo
                      }
                      alt={`${courseData.course_material.user.first_name} ${courseData.course_material.user.last_name}`}
                      className="User-photo"
                    />
                    <h3>{getDisplayName(user)}</h3>
                    <p className="user-role">Instructor</p>
                  </>
                ) : courseData.course_material.trainer ? (
                  <>
                    <img
                      src={
                        courseData.course_material.trainer.image_path
                          ? `${AxiosInstance.defaults.baseURL}/media/${courseData.course_material.trainer.image_path.replace(
                              /\\/g,
                              "/"
                            )}`
                          : courseData.course_material.trainer.gender === "Male"
                          ? MaleLogo
                          : FemaleLogo
                      }
                      alt="Trainer"
                      className="User-photo"
                    />
                    <h3>{getDisplayName(trainer)}</h3>
                    <p className="user-role">Instructor</p>
                  </>
                ) : (
                  <p>No trainer info available</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Topics & Subtopics */}
      <div className="cm-body topics-container">
        <h3 className="section-heading">About the course</h3>
        <div
          className="card-custom"
          dangerouslySetInnerHTML={{ __html: formatContent(description) }}
        />
        <h3 className="section-heading">Topics</h3>
        <div className="card-custom">
          {topics.map((topic) => {
            const isExpandedTopic = expandedTopic === topic.topic_id;

            return (
              <div key={topic.topic_id} className="topic-item">
                <div
                  className="topic-header d-flex justify-content-between align-items-center"
                  onClick={() =>
                    setExpandedTopic(isExpandedTopic ? null : topic.topic_id)
                  }
                  style={{ cursor: "pointer" }}
                >
                  <h5>{topic.topic_name}</h5>
                  {isExpandedTopic ? <FaChevronDown /> : <FaChevronRight />}
                </div>

                {isExpandedTopic && (
                  <div className="topic-content mt-2">
                    {/* Topic content */}
                    <div className="mb-2 ms-2 text-muted">
                      {topic.content ? (
                        <p>{topic.content}</p>
                      ) : (
                        <em>No topic content available.</em>
                      )}
                    </div>

                    {/* Video */}
                    {topic.video_link && (
                      <video controls className="w-100 mt-2">
                        <source
                          src={`${AxiosInstance.defaults.baseURL}/media/${topic.video_link.replace(
                            /\\/g,
                            "/"
                          )}`}
                          type="video/mp4"
                        />
                      </video>
                    )}

                    {/* Subtopics */}
                    {topic.subtopics.length > 0 ? (
                      <ul>
                        {topic.subtopics.map((sub) => {
                          const isExpandedSub =
                            expandedSubtopic === sub.sub_topic_id;
                          return (
                            <li key={sub.sub_topic_id} className="mb-2">
                              <div
                                className="subtopic-header d-flex justify-content-between align-items-center"
                                onClick={() =>
                                  setExpandedSubtopic(
                                    isExpandedSub ? null : sub.sub_topic_id
                                  )
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <span>{sub.sub_topic_name}</span>
                                {isExpandedSub ? (
                                  <FaChevronDown size={14} />
                                ) : (
                                  <FaChevronRight size={14} />
                                )}
                              </div>

                              {isExpandedSub && (
                                <div className="subtopic-content mt-2 ms-3 text-muted">
                                  {sub.sub_topic_content ? (
                                    <p>{sub.sub_topic_content}</p>
                                  ) : (
                                    <em>No subtopic content available.</em>
                                  )}

                                  {sub.video_link && (
                                    <video controls className="w-100 mt-2">
                                      <source
                                        src={`${AxiosInstance.defaults.baseURL}/media/${sub.video_link.replace(
                                          /\\/g,
                                          "/"
                                        )}`}
                                        type="video/mp4"
                                      />
                                    </video>
                                  )}
                                </div>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <p className="ms-2">
                        <em>No subtopics available.</em>
                      </p>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Reviews */}
        <div className="d-flex justify-content-between align-items-center mt-4">
          <h3 className="section-heading review-heading">Reviews</h3>

          {!userReview && !isEditing && (
            <button
              className="add-button btn-sm"
              onClick={() => {
                setIsEditing(true);
                setShowEditReviewModal(true);
                setRatingInput(0);
                setReviewInput("");
              }}
            >
              + Add Review
            </button>
          )}
        </div>

        <div className="card-custom mt-2">
          {reviews.length === 0 && <p>No reviews yet.</p>}

          {/* Display all reviews */}
          {reviews.map((review) => {
            const { trainee, review: comment, rating } = review;
            const fullName = `${trainee.first_name} ${trainee.last_name}`;
            const profileImage = trainee.image_path
              ? `${AxiosInstance.defaults.baseURL}/media/${trainee.image_path.replace(
                  /\\/g,
                  "/"
                )}`
              : trainee.gender === "Male"
              ? MaleLogo
              : FemaleLogo;

            return (
              <div
                key={review.review_id}
                className="review-item border p-3 mb-3 d-flex align-items-start"
              >
                <img
                  src={profileImage}
                  alt={fullName}
                  className="rounded-circle me-3"
                  style={{ width: "60px", height: "60px", objectFit: "cover" }}
                />
                <div className="flex-grow-1">
                  <h5 className="mb-1">{fullName}</h5>
                  <div className="mb-1">
                    {[...Array(5)].map((_, i) => {
                      if (i < Math.floor(rating))
                        return <FaStar key={i} color="#ffc107" />;
                      if (i === Math.floor(rating) && rating % 1 !== 0)
                        return <FaStarHalfAlt key={i} color="#ffc107" />;
                      return <FaRegStar key={i} color="#ccc" />;
                    })}
                  </div>
                  <p>{comment}</p>

                  {/* Edit/Delete buttons for current trainee */}
                  {trainee.trainee_id.toString() ===
                    currentTraineeId?.toString() &&
                    !isEditing && (
                      <div className="mt-2">
                        <button
                          className="btn btn-sm btn-outline-primary me-2"
                          onClick={() => {
                            setIsEditing(true);
                            setRatingInput(review.rating);
                            setReviewInput(review.review);
                            setShowEditReviewModal(true);
                          }}
                        >
                          <FiEdit />
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={handleDeleteReview}
                        >
                          <FiTrash />
                        </button>
                      </div>
                    )}
                </div>
              </div>
            );
          })}

          {/* Review Form Modal */}
          {showEditReviewModal && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {userReview ? "Edit Your Review" : "Post Your Review"}
                    </h5>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">Rating</label>
                      <input
                        type="number"
                        className="form-control"
                        value={ratingInput}
                        onChange={(e) =>
                          setRatingInput(parseFloat(e.target.value))
                        }
                        min={1}
                        max={5}
                        step={0.5}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Review</label>
                      <textarea
                        className="form-control"
                        rows="4"
                        value={reviewInput}
                        onChange={(e) => setReviewInput(e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => {
                        setShowEditReviewModal(false);
                        setIsEditing(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        handleSubmitReview();
                        setShowEditReviewModal(false);
                        setIsEditing(false);
                      }}
                      disabled={!ratingInput || !reviewInput.trim()}
                    >
                      {userReview ? "Update Review" : "Submit Review"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footers />
    </div>
  );
}
